@if (environment.production === false && isDevMode) {
  <div class="debug">
    <!-- Start debug area -->
    @if (debugToolService.data.length) {
      <h5>DebugTool.data:</h5>
    }
    @for (item of debugToolService.data; track item) {
      <ol>
        <li>{{ item | json }}</li>
      </ol>
    }
    <!--  <div *ngIf="dialogRef">-->
    <!--    ObjInfo Dialog ({{ dialogRef.id }}):-->
    <!--    {{ dialogRef.getState() === 0 ? 'Open' : 'Not open' }}-->
    <!--  </div>-->
    <!--  <ng-container-->
    <!--    *ngIf="-->
    <!--      objectinfoService.getStoredDialogSize()?.width ||-->
    <!--      objectinfoService.getStoredDialogSize()?.height-->
    <!--    ">-->
    <!--    <h5>objSvc.dialogSize:</h5>-->
    <!--    {{ objectinfoService.getStoredDialogSize() | json }}-->
    <!--  </ng-container>-->

    <!-- / End debug area-->
  </div>
}
